"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flex = void 0;

var _primitives = require("../../platform/primitives");

var _Box = require("../Box");

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * Flex is Box with display: flex
 */
var Flex = (0, _primitives.styledWrapper)(_Box.Box)(_templateObject());
exports.Flex = Flex;
Flex.defaultProps = {
  display: "flex"
};
Flex.displayName = "Flex";
//# sourceMappingURL=Flex.js.map